module.exports = __webpack_public_path__ + "img/25n.9bf42996.png";